module.exports = __webpack_public_path__ + "static/media/violinplay_awalkthroughthebinarytreeforest.0e35a027.wav";